  import toastrCss from '../Content/Css/toastr.min.css';   
  import bootstrapCss from '../Content/Css/bootstrap-bare.css'; 
  import ie10mobileCss from '../Content/Css/ie10mobile.css'; 
  import blockUICss from '../Content/Css/angular-block-ui.min.css'; 
  import siteCss from '../Content/Css/site.css'; 
  
  import angular from 'angular';
  import uirouter from 'angular-ui-router';
  import ngCookies from 'angular-cookies';
  import angularMessages from 'angular-messages';
  import toastr from 'angular-toastr';
  import blockUI from 'angular-block-ui';
  import ngSanitize from 'angular-sanitize';
  import ngFileSaver from 'angular-file-saver';
  import angularUI from '../vendor/angular-ui/ui-bootstrap-custom-tpls-2.2.0.min';  
  import constants from './constants/constants.js';
  import ngFileUpload from 'ng-file-upload';
  
  import routingConfiguration from './routing.configuration';
  import blockUIConfiguration from './block-ui.configuration';  
  import initConfigProvider from './initconfig.provider';
  import httpInterceptorService from './services/http-interceptor.service';
  import securityService from './services/security.service';
  import appInsightsService from './services/app-insights.service';
  import loggerService from './services/logger.service';
  import componentDataService from './services/component-data.service';
  import componentRegistryService from './services/component-registry.service';
  import tokenService from './services/token.service';
  import userService from './services/user.service';
  import disclosureService from './services/disclosure.service'
  import assessmentService from './services/assessment.service'
  import helperService from './services/helper.service';
  import userDetailsService from './services/user-details.service';
  import adminService from './services/admin.service';
  import dateTimeService from './services/date-time.service';
  import blobDownloadService from './services/blob-download.service';

  import lineAlternativeManagerComponent from './disclose/conflictOfInterest/components/line-alternative-manager/line-alternative-manager.component';
  import lineManagerSelectComponent from './disclose/conflictOfInterest/components/line-manager-select/line-manager-select.component';
  import lineAlternativeExecutiveManagerComponent from './components/line-alternative-executive-manager/line-alternative-executive-manager.component';
  import userValidateComponent from './components/user-validate/user-validate.component';
  import userDetailsComponent from './components/user-details/user-details.component';
  import conflictDetailsComponent from './disclose/conflictOfInterest/components/conflict-details/conflict-details.component';
  import textAreaComponent from './components/text-area/text-area.component';
  import radioInputComponent from './components/radio-input/radio-input.component';
  import conflictCategoryComponent from './disclose/conflictOfInterest/components/conflict-category/conflict-category.component';
  import acknowledgementsComponent from './components/acknowledgements/acknowledgements.component';
  import categoryStaticTextComponent from './disclose/conflictOfInterest/components/category-static-text/category-static-text.component';
  import closePersonalRelationshipComponent from './disclose/conflictOfInterest/components/close-personal-relationship/close-personal-relationship.component';
  import foreignInterferenceComponent from './disclose/conflictOfInterest/components/foreign-interference/foreign-interference.component';
  import foreignInterferenceQuestionComponent from './components/foreign-interference-question/foreign-interference-question.component';
  import errorSummaryComponent from './components/error-summary.component';
  import staffValidateComponent from './components/user-validate/user-validate.component';
  import secondaryEmploymentQuestionComponent from './disclose/conflictOfInterest/components/secondary-emp-ques/secondary-emp-ques.component';
  import textInputComponent from './components/text-input/text-input.component';
  import historyComponent from './components/history/history.component';
  import giftDetailsComponent from './disclose/gift/components/gift-details/gift-details.component';
  import confirmationComponent from './components/confirmation/confirmation.component';
  import giftRecipientsComponent from './disclose/gift/components/gift-recipients/gift-recipients.component';
  import executiveManagerSelectComponent from './components/executive-manager-select/executive-manager-select.component';
  import fileUploadComponent from './components/file-upload/file-upload.component';
  import fileListComponent from './components/file-list/file-list.component';
  import returnedCommentsComponent from './components/returned-comments/returned-comments.component';

  import managementStrategyOptionsComponent from './assess/conflictOfInterest/components/management-strategy-options/management-strategy-options.component';
  import managementStrategyTextComponent from './assess/conflictOfInterest/components/management-strategy-text/management-strategy-text.component';
  import giftManagementStrategyComponent from './assess/gift/components/gift-management-strategy/gift-management-strategy.component';
  import isuAssessmentComponent from './components/isu-assessment/isu-assessment.component';
  import deactivationComponent from './components/deactivation/deactivation.component';

  import loginController from './login/login.controller';
  import ssoController from './sso/sso.controller';
  import homeController from './home/home.controller';
  import adminController from './admin/admin.controller';
  import manageDisclosuresController from './admin/manage-disclosures.controller';
  import discloseController from './disclose/disclose.controller';
  import myDisclosuresController from './disclose/mydisclosures.controller'
  import conflictOfInterestController from './disclose/conflictOfInterest/conflictOfInterest.controller';
  import reviewController from './disclose/conflictOfInterest/review.controller';
  import successController from './disclose/success.controller';
  import assessmentSuccessController from './assess/assessment-success.controller';
  import giftController from './disclose/gift/gift.controller';
  import giftReviewController from './disclose/gift/gift.review.controller'; 
  import conflictOfInterestAssessmentController from './assess/conflictOfInterest/conflictOfInterestAssessment.controller';
  import giftAssessmentController from './assess/gift/gift-assessment.controller';
  import myTasksController from './assess/mytasks.controller' 
  import menuProvider from './menu.config.provider';
  import appMenuDirective from './menu/app-menu.directive';
  import stateMenuDirective from './menu/state-menu.directive';
  
  import appMain from './app.main';

angular.module('app', [uirouter, ngCookies, blockUI, angularMessages, toastr, ngSanitize, 'ui.bootstrap', ngFileSaver, 'ngFileUpload' ])
      .constant('USER_TOKEN_COOKIE_NAME', 'coi.usertoken')
      .constant('SSO_COOKIE_NAME', 'iPlanetDirectoryPro')
      .constant('constants', constants.getConstants())
      .provider('menuProvider', menuProvider)
      .provider('initConfigProvider', initConfigProvider)
      .provider("dateTimeService", function() {
          return {
              $get: function() {
                  return {formatDate: (d) => { return dateTimeService.formatDate(d) }}
              }
          }
      })
      .provider("textFormatter", function () {
          return {
              $get: function () {
                  return { formatText: (t) => { return t.replace(/\n/g, '<br />') } }
              }
      }})
      .service('appInsightsService', appInsightsService)
      .service('userService', userService)
      .service('helperService', helperService)
      .service('dateTimeService', dateTimeService)
      .service('userDetailsService', userDetailsService)
      .service('disclosureService', disclosureService)
      .service('assessmentService', assessmentService)
      .service('adminService', adminService)
      .service('blobDownloadService', blobDownloadService)
      .config(routingConfiguration.config)
      .config(['$httpProvider', function($httpProvider) {
              $httpProvider.interceptors.push(httpInterceptorService.config);
          }
      ])
      .config(blockUIConfiguration.config)           
      .component('categoryStaticText', categoryStaticTextComponent)
      .component('closePersonalRelationship', closePersonalRelationshipComponent)
      .component('foreignInterference', foreignInterferenceComponent)
      .component('foreignInterferenceQuestion', foreignInterferenceQuestionComponent)
      .component('lineAlternativeManager', lineAlternativeManagerComponent)
      .component('lineManagerSelect', lineManagerSelectComponent)
      .component('lineAlternativeExecutiveManager', lineAlternativeExecutiveManagerComponent)
      .component('secondaryEmploymentQuestion', secondaryEmploymentQuestionComponent)
      .component('userValidate', userValidateComponent)
      .component('textInput', textInputComponent)
      .component('userDetails', userDetailsComponent)
      .component('conflictDetails', conflictDetailsComponent)
      .component('textArea', textAreaComponent)
      .component('conflictCategory', conflictCategoryComponent)
      .component('acknowledgements', acknowledgementsComponent)
      .component('history', historyComponent)
      .component('giftDetails', giftDetailsComponent)
      .component('confirmation', confirmationComponent)
      .component('giftRecipients', giftRecipientsComponent)
      .component('executiveManagerSelect', executiveManagerSelectComponent)
      .component('fileUpload', fileUploadComponent)
      .component('fileList', fileListComponent)
      .component('radioInput', radioInputComponent)
      .component('returnedComments', returnedCommentsComponent)
      .component('managementStrategyOptions', managementStrategyOptionsComponent)
      .component('managementStrategyText', managementStrategyTextComponent)
      .component('giftManagementStrategy', giftManagementStrategyComponent)
      .component('isuAssessment', isuAssessmentComponent)
      .component('deactivation', deactivationComponent)
      .controller('loginController', loginController)
      .controller('ssoController', ssoController)
      .controller('homeController', homeController)
      .controller('adminController', adminController)
      .controller('manageDisclosuresController', manageDisclosuresController)
      .controller('discloseController', discloseController)
      .controller('myDisclosuresController', myDisclosuresController)
      .controller('conflictOfInterestController', conflictOfInterestController)
      .controller('reviewController', reviewController)
      .controller('successController', successController)
      .controller('assessmentSuccessController', assessmentSuccessController)
      .controller('giftController', giftController)
      .controller('giftReviewController', giftReviewController)
      .controller('conflictOfInterestAssessmentController', conflictOfInterestAssessmentController)
      .controller('giftAssessmentController', giftAssessmentController)
      .controller('myTasksController', myTasksController)
      .directive('appMenu', appMenuDirective.factory)
      .directive('stateMenu', stateMenuDirective.factory)
      .factory('$', [
          '$window', function($window) {
              return $window.jQuery;
          }
      ])
      .factory('_', [
          '$window', function($window) {
              return $window._;
          }
      ])
      .factory('tokenService', tokenService.tokenServiceFactory)
      .factory('securityService', securityService.securityServiceFactory)
      .factory('loggerService', loggerService.loggerServiceFactory)
      .factory('componentRegistryService', componentRegistryService.componentRegistryServiceFactory)
      .factory('componentDataService', componentDataService.componentDataServiceFactory)
      //overriding angular default exception handler so that we can log error in app insights (previously exceptional)
      .factory('$exceptionHandler', [
          '$log', 'appInsightsService', function($log, appInsightsService) {
              return function myExceptionHandler(exception, cause) {
                appInsightsService.logError(exception, cause);
                $log.warn(exception, cause);
              };
          }
      ])
      .component('errorSummary', errorSummaryComponent)
      .component('staffValidate', staffValidateComponent)
      .run(appMain.main);


// WEBPACK FOOTER //
// ./app/app.js